import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Img, Icon, Button } from 'components';
import { theme, Text } from 'styles';

export function Faq({ setRef }) {
  const data = [
    { 
      type: 'service',
      question: '응답 데이터의 신뢰도는 어떻게 보장하나요?',
      answer: `완료 기준으로 리워드가 지급되는 구조를 적용하고 있어 응답 품질을 확보하고 있습니다.\n또한 비정상 응답은 수집 단계에서 자동 필터링되며, 본인 인증 기반 참여 환경을 통해 신뢰도를 유지합니다.`,
    },
    { 
      type: 'service',
      question: '특정 연령이나 지역만 대상으로 설문이 가능한가요?',
      answer: `네, 가능합니다.\nN-Survey는 정교한 타겟 설정을 통해 성별, 연령, 지역 등 원하는 조건에 맞춰 설문을 진행할 수 있습니다.`,
    },
    { 
      type: 'service',
      question: '설문 결과는 언제쯤 받아볼 수 있나요?',
      answer: `설문 세팅 후 즉시 응답이 수집되며, 규모에 따라 다르지만 보통 3~4일 이내 완료됩니다.\n결과는 AI 리포트와 데이터 파일 형태로 설문 종료 후 제공됩니다.`,
    },
    { 
      type: 'service',
      question: '예산이 적은데도 진행이 가능한가요?',
      answer: `네, 가능합니다.\nN-Survey는 문항 수와 응답 수에 따라 유연하게 설계되기 때문에 소규모 테스트부터 대규모 조사까지 예산에 맞춰 진행할 수 있습니다.`,
    },
  ];

  const [activeIdx, setActiveIdx] = useState([]);
  const toggle = (index) => {
    setActiveIdx((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  return (
    <Container ref={setRef}>
      <Button $type="badge" $color="orange">
        <Icon name="badgeIcon" />
        N-Survey FAQ
      </Button>
      <Text $type="b40" $mType="b28" $padding="24px 0 64px" $mPadding="20px 0">
        자주 묻는 질문
      </Text>
      <ul>
        {data.map((q, idx) => {
          const isOpen = activeIdx.includes(idx);
          return (
            <li key={`q_${idx}`} className={isOpen ? 'open' : ''}>
              <div className="con_box">
                <Box className="q_box" onClick={() => toggle(idx)}>
                  <div className="question">
                    <p>{q.question}</p>
                  </div>
                  <Icon name="BtnAccordion" />
                </Box>
                {isOpen && (
                  <div className="answer">
                    {q.answer.split('\n').map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </Container>
  );
}

const Container = styled.div`
  padding: 80px 40px;
  max-width: 1600px;
  margin: 0 auto;
  position: relative;

  ul {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .con_box {
    background-color: white;
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid #ff6450; 
    box-shadow: 0px 4px 12px rgba(255, 100, 80, 0.1); 
    transition: all 0.3s ease;
  }

  .question p {
    /* theme.typo 에러 방지를 위한 안전한 참조 */
    ${({ theme }) => theme.typo?.bold?.lg ? css`${theme.typo.bold.lg}` : 'font-size: 20px; font-weight: 700;'};
    color: #1a1a1a;
    line-height: 1.4;
  }

  .answer {
    padding: 0 24px 24px 24px;
    background-color: white;
    p {
      ${({ theme }) => theme.typo?.regular?.md ? css`${theme.typo.regular.md}` : 'font-size: 16px;'};
      color: #666;
      line-height: 1.6;
    }
  }

  li .q_box svg {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease;
    transform: rotate(0deg); /* 기본 상태: 아래 화살표 */
  }

  li.open {
    .con_box {
      border-color: #ff6450; 
    }
    .q_box svg {
      transform: rotate(180deg);
    }
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 40px 20px;
    
    ul {
      gap: 16px;
    }
    li .q_box svg {
      width: 14px;
      height: 14px;
    }

    .question p {
      ${({ theme }) => theme.typo?.bold?.md ? css`${theme.typo.bold.md}` : 'font-size: 16px;'};
    }
  }
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  cursor: pointer;
`;